import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Fuel reimbursement multiplier.
 */
export const schema = z.number().nonnegative().max(3);

export type FuelMultiplier = z.infer<typeof schema>;

export const definition = define({
  key: 'fuel_multiplier',
  schema,
  label: 'Fuel Multiplier',
  description:
    'The multiplier used to calculate the fuel surcharge. This is a multiplier of the base fare. Min: 0.0, Max: 3.0.',
  warning: 'Does NOT affect clients with flat rate pricing.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 1.5,
});
